/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SportPersonRunIcon16Light } from './SportPersonRunIcon16Light';
import { SportPersonRunIcon16Regular } from './SportPersonRunIcon16Regular';
import { SportPersonRunIcon16Solid } from './SportPersonRunIcon16Solid';
import { SportPersonRunIcon20Light } from './SportPersonRunIcon20Light';
import { SportPersonRunIcon20Regular } from './SportPersonRunIcon20Regular';
import { SportPersonRunIcon20Solid } from './SportPersonRunIcon20Solid';
import { SportPersonRunIcon24Regular } from './SportPersonRunIcon24Regular';
import { SportPersonRunIcon24Solid } from './SportPersonRunIcon24Solid';
import { SportPersonRunIcon32Regular } from './SportPersonRunIcon32Regular';
import { SportPersonRunIcon64Regular } from './SportPersonRunIcon64Regular';
var sizes = {
    16: {
        light: SportPersonRunIcon16Light,
        regular: SportPersonRunIcon16Regular,
        solid: SportPersonRunIcon16Solid,
    },
    20: {
        light: SportPersonRunIcon20Light,
        regular: SportPersonRunIcon20Regular,
        solid: SportPersonRunIcon20Solid,
    },
    24: {
        regular: SportPersonRunIcon24Regular,
        solid: SportPersonRunIcon24Solid,
    },
    32: {
        regular: SportPersonRunIcon32Regular,
    },
    64: {
        regular: SportPersonRunIcon64Regular,
    },
};
export var SportPersonRunIcon = forwardRef('SportPersonRunIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
